import React from "react";

const PageConfidentialite = () => {
  return (
    <div style={{ maxWidth: "800px", margin: "auto" }}>
      <h1>Politique de confidentialité - Charte de protection des données </h1>
      <br />
      <h1>Éditeur du site </h1>
      DIGI-SMART <br />
      Numéro de SIREN : 802 930 552 <br />
      Responsable éditorial : Thierry PEDELOUP <br />
      Téléphone : : 05 61 16 38 28 <br />
      Email : contact[@]ethics-group.com <br />
      Site web : ethics-group.com <br /> <br />
      <h1>Hébergement</h1>
      Hébergeur : SCALEWAY SAS, 8 rue de la Ville l'Evêque 75008 Paris
      <br /> <br />
      <h1>Développement</h1>
      DIGI-SMART 2, avenue de l’Escadrille Normandie Niemen, 31700 Blagnac
      <br />
      <br />
      <h1>Conditions d’utilisation</h1>
      Easygouv porte une attention toute particulière à la protection des données personnelles de
      ses utilisateurs. Dès lors, nous nous engageons à respecter la loi n° 78-17 du 6 janvier 1978
      relative à l'informatique, aux fichiers et aux libertés, modifiée par le Règlement européen
      2016/679 du 27 Avril 2016 relatif à la protection des données personnelles. Les engagements,
      décrits dans la présente charte de protection des données personnelles, répondent aux valeurs
      et aux principes de comportement individuel de Easygouv.
      <br />
      En utilisant le site easygouv.com et l'application mobile mise à votre disposition, vous
      acceptez la collecte et l’utilisation de vos données personnelles de la manière décrite dans
      la présente Charte de protection des données.
      <br />
      <br />
      <h2>Champ d'application</h2>
      La présente Charte de protection des données décrit de quelle manière Easygouv, ainsi que
      l’ensemble des entités appartenant au même groupe, traitent vos données personnelles lorsque
      vous utilisez notre site internet et notre application mobile mis à votre disposition.
      <br /> <br />
      <h2>Easygouv traite vos données personnelles pour mieux vous servir</h2>
      Le responsable de traitement est la personne en charge d’un ou de plusieurs traitements de
      données à caractère personnel dont il détermine les finalités et les moyens. Easygouv est
      responsable de l’ensemble des traitements de vos données personnelles entrant dans le champ
      d’application mentionné ci-dessus.
      <br /> <br />
      Dans le cadre de ces traitements, vos données collectées peuvent être, notamment, les
      suivantes :
      <br />
      <li>Votre prénom, nom, adresse, date de naissance, e-mail, téléphone</li>
      <li>Vos données de localisation (pays, ville) </li>
      <li>Adresse IP </li>
      <li>Données de connexion et de navigation </li>
      <li> D’autres informations que vous souhaitez nous communiquer.</li>
      <br />
      Le caractère obligatoire ou facultatif des données vous est signalé lors de la collecte par un
      astérisque. Sachez que certaines données sont collectées automatiquement du fait de vos
      actions sur le site easygouv.com.
      <br />
      <br />
      Pour les finalités suivantes, vos données sont nécessaires aux fins des intérêts légitimes
      poursuivis par Easygouv :<li> Analyses statistiques </li>
      <li>
        Pour prévenir de la fraude ou toute autre action illicite et se conformer à nos obligations
        légales
      </li>
      <li> Les mises à jour de notre site easygouv.com et de nos applications mobiles.</li>
      <br />
      <br />
      Les moyens de la collecte de vos données personnelles sont :<br />
      Sur notre site easygouv.com et sur l'application mobile, ces données peuvent être collectées
      par le biais de formulaires que vous serez amenés à compléter ou automatiquement.
      <br />
      <br />
      <h2>Les destinataires de vos données</h2>
      Easygouv ne divulgue pas vos données personnelles à d’autres entreprises à des fins de
      marketing. Nous nous engageons à assurer des contrôles de sécurité appropriés pour protéger
      vos données personnelles contre tout danger prévisible. Easygouv peut parfois transférer à ses
      sous-traitants hors Union-Européenne vos données personnelles à des fins d'analyses de trafic.
      Dans le cas où Easygouv devait transférer des données en dehors de l’E.E.E., nous le ferons
      uniquement dans le respect des lois et règlements. En effet, pour les transferts
      internationaux, Easygouv s’appuie uniquement sur les décisions d’adéquation de la Commission
      Européenne ou sur des clauses contractuelles types qui seront conclues avec les organismes
      tiers. Nous nous engageons tous à traiter vos données personnelles de manière sécurisée.
      <br />
      <br />
      <h2>Liens vers d'autres sites</h2>
      Notre site peut contenir des liens vers d’autres sites Web que nous ne possédons pas ni
      n’exploitons. Dans la mesure où les sites liés ne font pas partis de Easygouv, nous ne les
      contrôlons pas et nous ne sommes pas responsables de leurs contenus, produits, services ou
      politiques et pratiques de confidentialité.
      <br />
      <br />
      <h2>Easygouv sécurise vos données personnelles</h2>
      Easygouv s’engage à protéger la sécurité, la confidentialité et l’intégrité de vos données
      personnelles fournies sur notre site easygouv.com, nos applications mobiles et en magasin,
      grâce à des mesures techniques et organisationnelles. Easygouv a nommé un Délégué à la
      protection des données dont la mission est de garantir la conformité des traitements que nous
      mettons en oeuvre et d’assurer l’exercice de vos droits.
      <br />
      <br />
      <h2>La gestion de vos données personnelles</h2>
      • Chez Easygouv, vous êtes maître de vos données personnelles
      <br />
      Quand vous fournissez des informations personnelles à Easygouv, dans le cadre de la création
      d’un compte utilisateur, vous avez accès à vos données et vous pouvez les mettre à jour, les
      modifier ou les supprimer à tout moment.
      <br />
      • Vos droits relatifs à la protection de vos données
      <br />
      Conformément à la loi n° 78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et
      aux libertés, modifiée par le Règlement européen 2016/679 du 27 Avril 2016 relatif à la
      protection des données personnelles, vous disposez de plusieurs droits pour la gestion de vos
      données.
      <br />
      • Le droit de rectification Le droit de demander à Easygouv la modification de vos
      informations inexactes sur sa base de données.
      <br />
      • Le droit à l’effacement Vous souhaitez que Easygouv efface vos informations contenues dans
      nos bases de données ? C’est possible.
      <br />
      • Le droit d’opposition et de retrait de consentement Vous souhaitez ne pas ou ne plus
      apparaître sur un fichier de nos bases, vous le pouvez en exerçant l’un de ces droits et à
      tout moment.
      <br />
      <br />
      <h2>Contact pour l’exercice de vos droits</h2>
      Easygouv se veut proche de ses utilisateurs. C’est pourquoi nous ne ménageons aucun effort
      pour vous assister. Pour toute question relative à la présente charte ou pour l’exercice de
      vos droits, vous pouvez nous envoyer conformément à la réglementation, une demande :
      <li> Un courrier électronique adressé à contact@ethics-group.com </li>
      <li>
        Un courrier postal adressé à Easygouv au 2, avenue de l’Escadrille Normandie Niemen, 31700
        Blagnac
      </li>
      <br />
      <h2>Mise à jour de notre charte de protection des données</h2>
      La présente charte peut être mise à jour périodiquement et sans préavis. Toute modification
      entre en vigueur immédiatement à partir de la publication de la nouvelle charte sur le Site
      easygouv.com et sur les applications mobiles. Toutefois, nous utilisons vos données
      personnelles conformément à la Charte en vigueur au moment où vous nous soumettez lesdites
      données.Nous vous avertirons de tout changement important de notre charte et solliciterons
      votre consentement si cela est nécessaire et impacte la finalité de la collecte de vos données
      personnelles. Afin de toujours rester conforme à la règlementation en vigueur relative à la
      protection des données personnelles, la présente charte est revue annuellement par nos
      services.
      <br /> <br />
      <h2>Loi et juridiction applicable</h2>
      La présente charte relative à la protection de vos données personnelles est régie par la loi
      française et tout litige à son sujet relèvera de la compétence exclusive des tribunaux
      français.
      <br />
      <br />
      Dernière mise à jour : 31 Mars 2025
    </div>
  );
};

export default PageConfidentialite;
